"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InformationBox = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const colors_1 = require("../../../styles/colors");
const material_1 = require("@mui/material");
const Typo_1 = require("../../atoms/Typo/Typo");
const TitleNode = styled_1.default.span `
  color: ${colors_1.$primaryNavy};
  text-transform: uppercase;
`;
const NameNode = styled_1.default.span `
  color: ${colors_1.$primaryBlack};
  letter-spacing: 0px;
  text-align: center;
`;
const Container = styled_1.default.div `
  display: flex;
  gap: 16px;
  justify-content: space-between;
`;
const InfoBox = styled_1.default.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
function InformationBox({ children, color, data, }) {
    const leftBorderColor = color || colors_1.$primaryBrand;
    const Box = styled_1.default.div `
    background-color: ${colors_1.$lightBlue};
    border-left: 8px solid ${leftBorderColor};
    border-radius: 4px;
    min-width: 366px; // 394px - (horizontal padding + left border)
    opacity: 1;
    padding: 6px 10px;
  `;
    return ((0, jsx_runtime_1.jsx)(Box, { children: (0, jsx_runtime_1.jsx)(Container, { children: (0, jsx_runtime_1.jsxs)(material_1.Stack, Object.assign({ direction: "row", spacing: 2 }, { children: [data === null || data === void 0 ? void 0 : data.map((element, index) => ((0, jsx_runtime_1.jsxs)(InfoBox, { children: [(0, jsx_runtime_1.jsx)(TitleNode, { children: (0, jsx_runtime_1.jsx)(Typo_1.Typo, Object.assign({ "data-testid": "title", variant: "subtitle3" }, { children: element.title })) }), (0, jsx_runtime_1.jsx)(NameNode, { children: (0, jsx_runtime_1.jsx)(Typo_1.Typo, Object.assign({ "data-testid": "name", variant: "subtitle2" }, { children: element.name })) })] }, index))), children] })) }) }));
}
exports.InformationBox = InformationBox;
